export default __webpack_public_path__ + "static/media/Send_fill.96b49c51.svg";